
export type PortalConhecimentoProps = {
  url: string
}

const PortalConhecimento = ({ url }: PortalConhecimentoProps) => {
  return (
    <iframe
      src={url}
      title="portaldoconhecimentoMicroUniverso"
      width="100%"
      height="100%"
    />
  ) 
}

export { PortalConhecimento }
